import { render, staticRenderFns } from "./Template138.vue?vue&type=template&id=0947434d&scoped=true&"
import script from "./Template138.vue?vue&type=script&lang=js&"
export * from "./Template138.vue?vue&type=script&lang=js&"
import style0 from "./Template138.vue?vue&type=style&index=0&id=0947434d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0947434d",
  null
  
)

export default component.exports